import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Image, Table, Spinner, Alert } from "react-bootstrap";

import Layout from '../../components/Layout/Layout';

export default function Home() {

    return (
        <>
            <Layout>

                <div className="webmaster_wrap">
                    <Container>
                        <Row>
                            <Col md={12}>
                                <div className="info d-flex align-items-start">
                                    <i className="fi fi-rr-info me-2"></i>
                                    <p>Web Master Consultancy Pte Ltd is hosting this application and request Myinfo on behalf of WebClouds Pte Ltd. The data retrieved from Myinfo are secured and encrypted.
                                    </p>
                                </div>
                            </Col>
                        </Row>

                        <div className="box mt-4">
                            <Row className="row_gap">
                                <Col md={6}>
                                    <div className="inner_box">
                                        <h3 className="box_title">Use Myinfo</h3>
                                        <div className="img_icon">
                                            <Image src="../assets/image/singpass_logo.svg" alt="Singpass Logo" fluid />
                                        </div>
                                        <div className="text">
                                            <p>Register with Singpass to use relevant Myinfo data and pre-fill the form for a hassle-free application.</p>
                                        </div>
                                        <div className="button">
                                            <Button href="./apply_loan.html" variant="danger" className="btn_primary">Retrieve Myinfo with Singpass</Button>
                                        </div>
                                    </div>
                                </Col>

                                <Col md={6}>
                                    <div className="inner_box">
                                        <h3 className="box_title">Complete an online application form</h3>
                                        <div className="img_icon">
                                            <Image src="../assets/image/clarity_note_icon.png" alt="Note icon" fluid />
                                        </div>
                                        <div className="text">
                                            <p>For foreigners or Singaporeans and PRs who do not have access to Singpass.</p>
                                        </div>
                                        <div className="button">
                                            <Button as={Link} to="/landing/apply-loan" variant="outline-light">Continue without Myinfo</Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>

            </Layout>
        </>
    );
}